import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMicrophone,
  faMicrophoneSlash,
} from '@fortawesome/pro-solid-svg-icons';

// actions
import { toggleMute } from '../../../../actions/telephony';

function MuteButton({
  size = '1x',
  className = '',
  style = {},
}) {
  const { muted } = useSelector(store => store.telephony);

  return (
    <button
      type="button"
      className={['btn btn-outline-secondary', className].join(' ')}
      style={{ borderRadius: '17px', ...style }}
      onClick={toggleMute}
      title={muted ? 'Unmute' : 'Mute'}
    >
      <FontAwesomeIcon icon={muted ? faMicrophoneSlash : faMicrophone} size={size} />
    </button>
  );
}

export default MuteButton;
